import {
  DEFAULT_CATALOG_SORT,
  type CatalogSortValue,
} from "./catalogSort.utils";

const SORT_VALUES: CatalogSortValue[] = ["newest", "price-asc", "price-desc"];

export interface CatalogListingParams {
  level1Id?: string;
  sortBy: CatalogSortValue;
  search: string;
  ageFilter: string;
  page: number;
}

export function parseCatalogSortValue(value: string | null): CatalogSortValue {
  if (value && SORT_VALUES.includes(value as CatalogSortValue)) {
    return value as CatalogSortValue;
  }
  return DEFAULT_CATALOG_SORT;
}

export function parseCatalogListingParams(searchParams: URLSearchParams) {
  const pageRaw = Number.parseInt(searchParams.get("page") ?? "1", 10);

  return {
    level1Id: searchParams.get("level1Id") ?? "",
    sortBy: parseCatalogSortValue(searchParams.get("sort")),
    search: searchParams.get("q") ?? "",
    ageFilter: searchParams.get("age") ?? "",
    page: Number.isFinite(pageRaw) && pageRaw > 0 ? pageRaw : 1,
  };
}

export function buildCatalogListingSearchParams(
  params: CatalogListingParams
): URLSearchParams {
  const next = new URLSearchParams();

  if (params.level1Id?.trim()) {
    next.set("level1Id", params.level1Id.trim());
  }
  if (params.sortBy !== DEFAULT_CATALOG_SORT) {
    next.set("sort", params.sortBy);
  }
  if (params.search.trim()) {
    next.set("q", params.search.trim());
  }
  if (params.ageFilter.trim()) {
    next.set("age", params.ageFilter.trim());
  }
  if (params.page > 1) {
    next.set("page", String(params.page));
  }

  return next;
}
